import Cookies from 'js-cookie';
import { currentAdminId } from '../../utils/v2';

export const MAIL_PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

const cookieName = (tableKey: string) =>
    `crm_mail_page_size_${currentAdminId() || 'anonymous'}_${tableKey}`;

export const readMailPageSize = (tableKey: string, fallback: number) => {
    const saved = Number(Cookies.get(cookieName(tableKey)));
    return MAIL_PAGE_SIZE_OPTIONS.includes(String(saved)) ? saved : fallback;
};

export const rememberMailPageSize = (tableKey: string, pageSize?: number) => {
    if (!pageSize || !MAIL_PAGE_SIZE_OPTIONS.includes(String(pageSize))) return;
    Cookies.set(cookieName(tableKey), String(pageSize), {
        expires: 365,
        path: '/',
        sameSite: 'lax',
    });
};
